import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

const Layout = ({ children, meta }) => {
  const router = useRouter();
  const DEFAULT_SEO = {
    title: "Auckland Rescue",
    description:
      meta.description ||
      "As one of New Zealand’s most trusted charities and an essential medical service, we are reliant on the community’s goodwill and support to help keep us operational 24 hours of the day, 365 days of the year. Through this care, we can assist patients and their loved ones in their greatest time of need.",
    keywords: "marketplace",
    openGraph: {
      type: "website",
      locale: "en_IE",
      url: `${process.env.SITE_URL}${router.asPath}`,
      title: "Auckland Rescue",
      description:
        meta.description ||
        "As one of New Zealand’s most trusted charities and an essential medical service, we are reliant on the community’s goodwill and support to help keep us operational 24 hours of the day, 365 days of the year. Through this care, we can assist patients and their loved ones in their greatest time of need.",

      site_name: "Auckland Rescue",
      images: [
        {
          url: `${process.env.SITE_URL}/assets/home/top-logo.png`,
          width: 164,
          height: 46,
          alt: "auckland-rescue",
        },
      ],
    },
  };

  return (
    <>
      <NextSeo {...DEFAULT_SEO} />
      <>{children}</>
    </>
  );
};

export default Layout;
